module.exports = __webpack_public_path__ + "static/media/8.9a0ae4b2.jpg";